/*eslint-disable*/
import React, {Component} from 'react'
import './css/App.css'
import './css/reset.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap-theme.min.css'
import 'react-select/dist/react-select.css'

import Dashboard from './containers'
const referrer = document.referrer.split('/')[2];
const go = (referrer === 'unifier.sandi.net' || referrer === 'prdecprwb08') || document.location.hostname === 'localhost';
class App extends Component {
  state = {go};

  render() {
    const {go} = this.state;
    return (
      go ? <Dashboard/> : <NotUnifier/>
    );
  }
}

export default App;

const NotUnifier = () => {
  return (
    <div style={{padding: '5rem'}}>
      <h1>NOTICE</h1>
      <h4>This app must be viewed within the unifier portal.</h4>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/App.js